import { isValid, parseISO } from "date-fns";
import { StrictTypedTypePolicies } from "../../gql/__generated__/graphql";

const DateField = (date: any) => {
  if (!date) return null;
  if (isValid(date)) return date;
  return parseISO(date);
};

export const typePolicies: StrictTypedTypePolicies = {
  Organization: {
    fields: {
      createdAt: DateField,
      members: {
        merge(_, incoming) {
          return incoming;
        }
      },
      apps: {
        merge(_, incoming) {
          return incoming;
        }
      }
    }
  },
  AppSubscription: {
    fields: {
      createdAt: DateField,
      expiresAt: DateField,
      apiKeys: {
        merge(_, incoming) {
          return incoming;
        }
      }
    }
  },
  AppDeployment: {
    fields: {
      apiKeys: {
        merge(_, incoming) {
          return incoming;
        }
      }
    }
  },
  GithubRepositoryRelease: {
    fields: {
      publishedAt: DateField
    }
  },
  StandingOffer: {
    fields: {
      createdAt: DateField
    }
  },
  UserPreferences: {
    merge: true
  },
  OrganizationInvitation: {
    fields: {
      invitedAt: DateField
    }
  }
};
